import React from 'react';
import useLandlordData     from '../hooks/useLandlordData';
import MaintenanceTicket   from '../components/MaintenanceTicket';

export default function Maintenance() {
  const { maintenance, loading, error } = useLandlordData();
  if (loading) return <p>Loading tickets…</p>;
  if (error)   return <p>Error loading tickets.</p>;

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Maintenance Requests</h2>
      <MaintenanceTicket tickets={maintenance} />
    </div>
  );
}

const styles = {
  container: { padding: '2rem', fontFamily: 'Arial, sans-serif' },
  heading:   { fontSize: '1.5rem', marginBottom: '1rem' }
};